import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMapCourseDetails from "./routes/GradeMapCourseDetails";

export default store => ({
  path: "course",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-map-course" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GradeMapCourseDetails(store)],
});
